/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ViewApplicationRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model(params) {
    return hash({
      application: this.store.findRecord(
        'enrolments/application',
        params.application_id,
      ),
      schemas: this.store.query('enrolments/schema', {
        schoolId: this.get('session.activeSchool'),
      }),
      fieldGroups: this.store.query('people-schema/group', {
        personType: PersonType.LEARNER,
        include: 'fields',
      }),
      caregiverFieldGroups: this.store.query('people-schema/group', {
        personType: PersonType.CAREGIVER,
        include: 'fields',
      }),
      medicalFieldGroups: this.store.query('people-schema/group', {
        personType: PersonType.MEDICAL,
        include: 'fields',
      }),
    });
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    // Extract the schema object, if present
    if (!isEmpty(model.schemas)) {
      controller.set('schema', model.schemas[0]);
    }
  }

  resetController(controller) {
    if (!isEmpty(controller)) {
      controller.reset();
    }
  }
}
